import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface material {
    id: number,
    name?: string,
    description?: string,
    code?: string,
    is_priced?:string
}

export interface glassPrice {
    pid: number,
    price: number,
    gid: number,
    gname: string,
    gcode: number,
    is_priced: number,
    gwid: number,
    gwname: string,
    gwcode: number,
    min_area: number,
    unit: string,
}

// Materials state
interface iMaterial {[key:number]:material[]| null}

export interface materialsState {
    isLoaded: boolean, // First load
    isLoading: boolean, // On filtering laoder
    isFetching: boolean,
    hasMore: boolean,
    showMaterial: boolean,
    material?: material,
    materials: iMaterial,
    glassPrices: glassPrice[],
    page:number,
    subPage:number

}

const initialMaterialsState: materialsState = {
    isLoaded: false,
    isLoading: false,
    isFetching: false,
    hasMore: true,
    showMaterial: false,
    materials: {
        1:[]
    },
    glassPrices: [],
    page:1,
    subPage:1
}

// Users slice
export const materialsSlice = createSlice({
    name: 'materials',
    initialState: initialMaterialsState,
    reducers: {
        setIsLoaded: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoaded = payload
        },
        setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoading = payload
        },
        setIsFetching: (state, { payload }: PayloadAction<boolean>) => {
            state.isFetching = payload
        },
        setHasMore: (state, { payload }: PayloadAction<boolean>) => {
            state.hasMore = payload
        },
        setMaterial: (state, { payload }: PayloadAction<{ showMaterial: boolean, material?: material }>) => {
          
            state.showMaterial = payload.showMaterial
                state.material = payload.material
        },
        initializeMaterials :(state, { payload }: PayloadAction<material[]>) => {
  
            state.materials [state.page]=   [...payload]
        
        },
        addMaterials: (state, { payload }: PayloadAction<material[]>) => {
            state.materials [state.page]=    state.materials [state.page]?
            [ ...(state.materials [state.page]?? []),...payload]:[...payload]
        
        },
        updateMaterial: (state, { payload }: PayloadAction<material>) => {
            let index =    state.materials[state.page]!.findIndex(material => material.id === payload.id)
            if (index !== -1)
            state.materials [state.page]![index] = payload
        },
        deleteMaterials: (state, { payload }: PayloadAction<number[]>) => {
            payload.map(id => {
                let index =    state.materials [state.page]!.findIndex(material => material.id === id)
                if (index != -1)
                state.materials [state.page]!.splice(index, 1)
                if (state.material?.id=== id){
                    state.material=undefined
                }
            })
        },
        addGlassPrices: (state, { payload }: PayloadAction<glassPrice[]>) => {
         
            state.glassPrices =payload 
        },
        updateGlassPrice: (state, { payload }) => {
       
            let index = state.glassPrices.findIndex(glassPrice => glassPrice.pid === payload[0].pid)
  
            if (index !== -1)
                state.glassPrices = payload
        },
        deleteGlassPrices: (state, { payload }: PayloadAction<number>) => {
            let index = state.glassPrices.findIndex(glassPrice => glassPrice.pid === payload)
            if (index != -1)
            state.glassPrices.splice(index, 1)
        },
        reset: (state) => {
            state.materials = []
            state.hasMore = true
        },
        setPage:(state,{payload}:PayloadAction<number>)=>{
            state.page=payload
        },
        setSubPage:(state,{payload}:PayloadAction<number>)=>{
            state.subPage=payload
        }
    }
})